import {
	type ThemePreference,
	isThemePreference,
} from "@memorang/ui/components/AccountSettingsApplet/dialogs/theme-preference";
import type { ColorSchemeName } from "react-native";

export type { ThemePreference };

export type StoredThemePreferenceResolution = {
	preference: ThemePreference;
	needsPersistence: boolean;
};

export const resolveStoredThemePreference = ({
	storedPreference,
	legacyIsDarkMode,
}: {
	storedPreference: unknown;
	legacyIsDarkMode: unknown;
}): StoredThemePreferenceResolution => {
	if (isThemePreference(storedPreference)) {
		return { preference: storedPreference, needsPersistence: false };
	}

	if (storedPreference !== null && storedPreference !== undefined) {
		return { preference: "system", needsPersistence: true };
	}

	if (legacyIsDarkMode === true) {
		return { preference: "dark", needsPersistence: true };
	}

	if (legacyIsDarkMode === false || legacyIsDarkMode === "") {
		return { preference: "light", needsPersistence: true };
	}

	return { preference: "system", needsPersistence: true };
};

export const resolveIsDarkMode = (
	preference: ThemePreference,
	systemColorScheme: ColorSchemeName | null,
): boolean =>
	preference === "dark" ||
	(preference === "system" && systemColorScheme === "dark");

export const getOppositeThemePreference = (
	isDarkMode: boolean,
): Exclude<ThemePreference, "system"> => (isDarkMode ? "light" : "dark");
